import React, { useState } from 'react';
import { Button, Input, Row } from 'reactstrap';

const RankPicker = ({ rank: initialRank, setTemplateRank }) => {
  const [rank, setRank] = useState(`${!initialRank && initialRank !== 0 ? 'none' : initialRank}`);
  const initialRankStr = `${!initialRank && initialRank !== 0 ? 'none' : initialRank}`;
  const onChange = ({ target: { value } }) => {
    setRank(value);
  };

  return (
    <div style={styles.container}>
      <Row>
        <p style={styles.label}>{`Rank (current: ${initialRankStr})`}</p>
        <Input
          id="rank-input"
          name="Rank"
          onChange={onChange}
          placeholder={rank}
          style={styles.input}
          type="number"
          value={rank}
        />
        <Button color="info" onClick={() => setTemplateRank(rank)} style={styles.button}>
          Change rank
        </Button>
      </Row>
    </div>
  );
};

const styles = {
  container: {
    flex: 1,
  },
  col: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginVertical: 15,
  },
  label: {
    top: -2,
  },
  input: {
    marginLeft: 10,
    width: 100,
  },
  button: {
    marginLeft: 10,
  },
};

export default RankPicker;



// WEBPACK FOOTER //
// ./src/components/templates-manager/template-components/RankPicker.js